/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GraduatoriaEligibilitaNodoForm } from './graduatoria-eligibilita-nodo-form';


export interface GraduatoriaAnteprimaEligibilitaForm { 
    eligibilita?: Array<GraduatoriaEligibilitaNodoForm>;
}

